export default "__VITE_ASSET__jZkMW6eT__"